module.exports = __webpack_public_path__ + "img/balcony.b3700bf3.png";